import { useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { useAuth } from "../../contexts/AuthContext";
import { useGetCurrentUserProfile } from "../../api/generated/generated";
import hanoverLogo from "../../assets/hanover.jpg";

export function PendingApprovalPage() {
  const { signOut, refreshToken } = useAuth();

  // Call /users/me to ensure profile is created server-side
  useGetCurrentUserProfile();

  const handleFocus = useCallback(() => {
    refreshToken();
  }, [refreshToken]);

  useEffect(() => {
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [handleFocus]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper sx={{ p: 4, textAlign: "center", width: "100%" }}>
          <Box sx={{ mb: 3 }}>
            <img src={hanoverLogo} alt="Hanover Coach" style={{ height: 48 }} />
          </Box>

          <HourglassEmptyIcon
            sx={{ fontSize: 48, color: "warning.main", mb: 2 }}
          />

          <Typography variant="h5" gutterBottom>
            Account Pending Approval
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              mb: 3
            }}>
            Your account is awaiting approval from an administrator. You&apos;ll
            gain access once your account has been reviewed.
          </Typography>

          <Button variant="outlined" onClick={signOut}>
            Log Out
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}
